import React, { Component } from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import InfiniteScroll from 'react-infinite-scroller';
import MDSpinner from 'react-md-spinner';
import { Scrollbars } from 'react-custom-scrollbars';
import { SEARCH_TYPE, PAGE_SIZE, WAIT_INTERVAL } from '../constants.js';
import { s as styles, G as GiphyEmptyState } from '../giphyEmptyState-908a0922.js';
import PoweredByGiphy from '../icons/PoweredByGiphy.js';
import '../style-inject.es-746bb8ed.js';

class GiphySelector extends Component {
  constructor(props) {
    super(props);
    this.getGifs = (searchTag, page) => {
      if (searchTag) {
        this.giphySdkCore.search(SEARCH_TYPE, { q: searchTag, offset: page * PAGE_SIZE, limit: PAGE_SIZE }).then((response) => {
          if (page > 1) {
            this.setState({
              gifs: this.state.gifs.concat(response.data),
              hasMoreItems: true,
              page: this.state.page + 1,
              didFail: false
            });
          } else {
            this.setState({
              gifs: response.data,
              hasMoreItems: true,
              page: this.state.page + 1,
              didFail: false
            });
          }
        }).catch(() => {
          this.setState({ didFail: true, hasMoreItems: false });
        });
      } else {
        this.giphySdkCore.trending(SEARCH_TYPE, { limit: 100 }).then((response) => {
          if (!searchTag) {
            this.setState({ gifs: response.data, hasMoreItems: false, didFail: false });
          }
        }).catch(() => {
          this.setState({ didFail: true, hasMoreItems: false });
        });
      }
    };
    this.getMoreGifs = () => {
      const searchTag = this.props.searchTag;
      this.getGifs(searchTag, this.state.page);
    };
    this.getBoundOnClick = (giphy) => {
      const componentData = this.convertGiphyToComponentData(giphy);
      return () => this.selectGif(componentData);
    };
    this.getBoundKeyDown = (giphy) => {
      const componentData = this.convertGiphyToComponentData(giphy);
      return (e) => {
        const { onCloseRequested } = this.props;
        if (e.key === "Escape") {
          onCloseRequested == null ? void 0 : onCloseRequested();
        }
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.selectGif(componentData);
        }
      };
    };
    const { componentData } = this.props;
    this.state = {
      url: componentData.src || "",
      isLoaded: false,
      hasMoreItems: true,
      gifs: [],
      page: 0,
      didFail: false
    };
    this.styles = mergeStyles({ styles, theme: this.props.theme });
    const gphApiClient = require("giphy-js-sdk-core");
    this.giphySdkCore = gphApiClient(this.props.giphySdkApiKey);
  }
  selectGif(gif) {
    const { onGifAdd, onCloseRequested } = this.props;
    onGifAdd(gif);
    onCloseRequested();
  }
  convertGiphyToComponentData(giphy) {
    var _a, _b, _c;
    return {
      originalUrl: giphy.images.original.url,
      originalMp4: giphy.images.original.mp4,
      stillUrl: giphy.images.original_still.url,
      downsizedUrl: ((_a = giphy.images.downsized) == null ? void 0 : _a.url) || giphy.images.original.url,
      downsizedStillUrl: ((_b = giphy.images.downsized_still) == null ? void 0 : _b.url) || giphy.images.original.url,
      downsizedSmallMp4: ((_c = giphy.images.downsized_small) == null ? void 0 : _c.mp4) || giphy.images.original.mp4,
      height: parseInt(giphy.images.original.height, 10),
      width: parseInt(giphy.images.original.width, 10)
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.getGifs(nextProps.searchTag), WAIT_INTERVAL);
  }
  componentDidMount() {
    this.timer = null;
  }
  render() {
    const { styles: styles2 } = this;
    const { t, searchTag } = this.props;
    const { gifs, hasMoreItems, didFail } = this.state;
    const loader = /* @__PURE__ */ React.createElement("div", { className: styles2[`giphy_selecter_spinner_${gifs.length ? "more" : "empty_modal"}`] }, /* @__PURE__ */ React.createElement(MDSpinner, { borderSize: 1.5, singleColor: "#000000" }));
    return /* @__PURE__ */ React.createElement("div", { "data-hook": "giphySelector" }, /* @__PURE__ */ React.createElement("div", { className: styles2.giphy_selecter_infinite_scroll_container }, !gifs.length && searchTag ? /* @__PURE__ */ React.createElement(GiphyEmptyState, { t }) : /* @__PURE__ */ React.createElement(
      Scrollbars,
      {
        renderThumbVertical: () => /* @__PURE__ */ React.createElement("div", { className: styles2.giphy_selecter_scrollbarThumb }),
        className: styles2.giphy_selecter_customize_scrollbar_container
      },
      /* @__PURE__ */ React.createElement(
        InfiniteScroll,
        {
          pageStart: 0,
          loadMore: this.getMoreGifs.bind(this),
          hasMore: hasMoreItems,
          loader: !this.state.didFail ? loader : null,
          useWindow: false,
          className: styles2.giphy_selecter_infinite_scroll
        },
        gifs.map((giphy, i) => {
          return /* @__PURE__ */ React.createElement(
            "div",
            {
              key: i,
              role: "button",
              tabIndex: 0,
              className: styles2.giphy_selecter_gif_img_container,
              onKeyDown: this.getBoundKeyDown(giphy),
              onClick: this.getBoundOnClick(giphy)
            },
            /* @__PURE__ */ React.createElement(
              "img",
              {
                className: styles2.giphy_selecter_gif_img,
                src: giphy.images.fixed_width_downsampled.webp || giphy.images.fixed_width_downsampled.url,
                alt: giphy.title || "gif"
              }
            )
          );
        })
      )
    )), /* @__PURE__ */ React.createElement("div", { className: styles2.giphy_selecter_container }, /* @__PURE__ */ React.createElement(PoweredByGiphy, { className: styles2.giphy_selecter_powerdByGiphy })), didFail && !gifs.length ? /* @__PURE__ */ React.createElement("div", { className: styles2.giphy_selecter_error_msg }, " ", t("GiphyPlugin_ApiErrorMsg")) : null);
  }
}

export { GiphySelector as default };
//# sourceMappingURL=giphySelector.js.map
